module.exports = __webpack_public_path__ + "static/image7-828021bdf0dadafe9f2792986bc5d354.jpg";